import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { Table } from "~/components/common/parts/table/Table";
import { TableBody } from "~/components/common/parts/table/TableBody";
import { TableHeader } from "~/components/common/parts/table/TableHeader";
import { SummaryFileTemplateRow } from "~/components/specifics/settings/file_templates/SummaryFileTemplateRow";
import { summaryFileTemplateTypes } from "~/models/SummaryFileTemplate";

export function Page() {
	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader title="帳票設定" />
					<PanelBody>
						<Table>
							<TableHeader>
								<th>区分</th>
								<th>宛先</th>
								<th>種別</th>
								<th>設定</th>
							</TableHeader>
							<TableBody>
								{summaryFileTemplateTypes.map((fileType) => (
									<SummaryFileTemplateRow fileType={fileType} key={fileType} />
								))}
							</TableBody>
						</Table>
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
